import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class UploadArqService {

  private s3PresignedUrlApi = 'https://qzcgyuf7l0.execute-api.sa-east-1.amazonaws.com/v1/ANY';

  constructor(private http: HttpClient) { }

  uploadFileWithParameters(bucket: string, key: string, action: string): Observable<any> {
    const data = {
      bucket: bucket,
      key: key,
      action: action,
    };
    return this.http.post(`${this.s3PresignedUrlApi}`, data);
  }

  uploadFile(presignedUrl: string, file: File): Observable<any> {
    // console.log(presignedUrl)
    // console.log(file)
    // console.log(file.type)
    const options = {
      headers: {
        'Content-Type': file.type,
      },
    };
    return this.http.put(presignedUrl, file, options);
  }

  public async getURL(urlConsulta: string): Promise<any> {
    const resposta = await this.http.get<string>(urlConsulta).toPromise();
    // console.log(resposta)
    if(resposta)
    return resposta;
  }
}



